/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Regenerate_TitleInputs */



/**
* | output |
* | --- |
* | "Write the report again?" |
*
* @param {Meeting_Report_Regenerate_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_regenerate_title = /** @type {((inputs?: Meeting_Report_Regenerate_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Regenerate_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verslag opnieuw maken?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refaire le compte rendu ?")
	return /** @type {LocalizedString} */ ("Write the report again?")
});